import * as types from "../../actions/generalledger/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_GL_ACCOUNT_TYPE_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
